import ArrowUpRight from "Assets/Icons/ArrowUpRightIcon";
import styled from "styled-components";
import { ScheduleStatusColor } from "utilFunctions/shared/ScheduleStatus";
import FacultyStarIcon from "Assets/Icons/FacultyStarIcon";
import { useState } from "react";
import FeedbackViewModal from "Pages/Faculties/FeedbackViewModal";
const HeadingDiv: any = styled<any>("div")`
  font-weight: 700;
  font-size: 28px;
  color: #333333;
`;
const ScheduleStatuSpan: any = styled<any>("span")`
  color: ${({ color }: any) => color};
  font-size: 16px;
  font-weight: 600;
  width: 100%;
`;
const ScheduleStatuSpan2: any = styled<any>("span")`
  color: #828282;
  font-size: 16px;
  font-weight: 600;
  margin-left: 5px;
`;
const StyledCard: any = styled<any>("div")`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100%;
  width: 100% !important;
  background: #fff;
`;

const LectureCountCard = ({
  totalUnmarkedLectures,
  batchCount,
  navigate,
  userInfo,
  facultyFeedbackData,
  setYearMonthForFeedback,
  dateFilterValues,
  facultyFeedbackHomeData,
}: any) => {
  const [isLectureViewModal, setIsLectureViewModal] = useState<any>(false);
  return (
    <div
      className="d-flex flex-row w-100"
      style={{
        paddingBottom: "16px",
        height: "148px",
        width: "100% !important",
        gap: "16px",
        overflow: "auto",
      }}
    >
      <FeedbackViewModal
        mode="myBatchLecture"
        selectedlecture={null}
        isLectureViewModal={isLectureViewModal}
        setIsLectureViewModal={setIsLectureViewModal}
        setYearMonthForFeedback={setYearMonthForFeedback}
        dateFilterValues={dateFilterValues}
        facultyFeedbackData={facultyFeedbackData}
      ></FeedbackViewModal>
      <StyledCard
        className="headerContent"
        onClick={() => {
          navigate("/admin/schedule", {
            replace: false,
            state: {
              isNotMarkedVisible: true,
            },
          });
        }}
      >
        <HeadingDiv totalUnmarkedLectures>
          {totalUnmarkedLectures > 0
            ? totalUnmarkedLectures
            : totalUnmarkedLectures + "🎉"}
        </HeadingDiv>
        <div style={{ whiteSpace: "nowrap" }}>
          <ScheduleStatuSpan
            color={
              totalUnmarkedLectures > 0
                ? ScheduleStatusColor("Not Marked")
                : "green"
            }
          >
            Unmarked
          </ScheduleStatuSpan>
          <ScheduleStatuSpan2>
            Lectures
            <ArrowUpRight className="cursorHoverCSS" />
          </ScheduleStatuSpan2>
        </div>
      </StyledCard>
      <StyledCard
        className="headerContent"
        onClick={() => {
          navigate("/admin/batches");
        }}
      >
        <HeadingDiv>{batchCount}</HeadingDiv>
        <div style={{ whiteSpace: "nowrap" }}>
          <ScheduleStatuSpan2>
            My Batches
            <ArrowUpRight className="cursorHoverCSS" />
          </ScheduleStatuSpan2>
        </div>
      </StyledCard>
      <StyledCard
        className="headerContent"
        onClick={() => {
          // navigate("/admin/faculties/" + userInfo?.id, {
          //   replace: true,
          //   state: {
          //     selectedStudent: userInfo?.id,
          //   },
          // });
          console.log("userInfo", userInfo);
          setIsLectureViewModal(!isLectureViewModal);
        }}
      >
        <HeadingDiv>
          {<FacultyStarIcon />}{" "}
          {facultyFeedbackHomeData !== null ? facultyFeedbackHomeData : "NA"}
        </HeadingDiv>
        <div style={{ whiteSpace: "nowrap" }}>
          <ScheduleStatuSpan2>
            Overall Rating
            <ArrowUpRight className="cursorHoverCSS" />
          </ScheduleStatuSpan2>
        </div>
      </StyledCard>
    </div>
  );
};
export default LectureCountCard;
